module.exports = __webpack_public_path__ + "static/Corprate_Careers_19-6bd4e49b2d9e019e67e7b64f3ee2885a.jpg";